<script setup>
import { ref } from 'vue'
import Breadcrumb from './Breadcrumb.vue'

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  breadcrumbs: {
    type: Array,
    default: () => []
  },
  tabs: {
    type: Array,
    required: true
  },
  defaultActiveTab: {
    type: String,
    default: ''
  }
})

const activeTab = ref(props.defaultActiveTab || (props.tabs.length > 0 ? props.tabs[0].id : ''))

const emit = defineEmits(['tab-change'])

const changeTab = (tabId) => {
  activeTab.value = tabId
  emit('tab-change', tabId)
}
</script>

<template>
  <div>
    <!-- Header con título y breadcrumbs -->
    <div class="flex items-center justify-between mb-8">
      <Breadcrumb :breadcrumbs="breadcrumbs" />
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-4 gap-6">
      <!-- Sidebar de navegación -->
      <div class="lg:col-span-1">
        <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <div class="p-6 border-b border-gray-200">
            <h3 class="text-lg font-medium text-gray-800">Categorías</h3>
          </div>
          <div class="divide-y divide-gray-200">
            <div
              v-for="tab in tabs"
              :key="tab.id"
              :class="[
                'p-4 transition-colors duration-150 cursor-pointer',
                activeTab === tab.id
                  ? 'bg-indigo-50 border-l-4 border-indigo-500'
                  : 'hover:bg-gray-50 border-l-4 border-transparent'
              ]"
              @click="changeTab(tab.id)"
            >
              <div class="flex items-center">
                <component
                  :is="tab.icon"
                  class="h-5 w-5 mr-3"
                  :class="activeTab === tab.id ? 'text-indigo-600' : 'text-gray-500'"
                />
                <span
                  :class="activeTab === tab.id ? 'font-medium text-indigo-700' : 'text-gray-700'"
                >
                  {{ tab.label }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Contenido principal -->
      <div class="lg:col-span-3">
        <slot :active-tab="activeTab"></slot>
      </div>
    </div>
  </div>
</template>
